import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=0687afde&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Editor.vue?vue&type=style&index=1&id=0687afde&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687afde",
  null
  
)

export default component.exports